import { Station } from '@app/core/types/stations';

/**
 * Face recognition runs under video analysis. The station DTO from the BFF does not
 * expose `videoAnalysis.faceRecognition` yet (tenants mapper only maps lowerThird,
 * adOverlays and screenBug), so the flag is honored only when present.
 * ponytail: costs one empty facerecognition request per range on video-analysis
 * stations without face data; drop the fallback once the BFF sends the flag.
 */
export function isFaceRecognitionEnabled(station: Station): boolean {
  const va = station.featuresConfig?.videoAnalysis;
  if (!va?.enabled) {
    return false;
  }
  return va.faceRecognition?.enabled ?? true;
}
